import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { siteInfo } from '../data/content';

const Footer = () => {
  return (
    <footer className="text-white py-12" style={{ backgroundColor: '#4F6E78' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="mb-4 flex items-center gap-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_e8a7a8e1-af64-416b-ba2f-55c511897d70/artifacts/4kvgjbnu_paix_logo_web.png" 
                alt="Paix Family Mediation"
                className="h-24 w-auto"
              />
              <img 
                src="https://customer-assets.emergentagent.com/job_2b8b53d6-f420-42d5-9708-89a0fcd9ca22/artifacts/fwrlqx0j_MMT%20Training%20Completion%20Seal.png" 
                alt="Mosten Mediation Training - Trained Mediator"
                className="h-36 w-auto"
                data-testid="certification-badge"
              />
            </div>
            <p className="text-sm opacity-90 mb-4">
              {siteInfo.vision}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <nav className="flex flex-col space-y-2">
              <Link to="/about" className="text-sm opacity-90 transition-opacity hover:opacity-100" style={{ color: 'inherit' }}>
                About
              </Link>
              <Link to="/services" className="text-sm opacity-90 transition-opacity hover:opacity-100" style={{ color: 'inherit' }}>
                Services
              </Link>
              <Link to="/how-it-works" className="text-sm opacity-90 transition-opacity hover:opacity-100" style={{ color: 'inherit' }}>
                How It Works
              </Link>
              <Link to="/faq" className="text-sm opacity-90 transition-opacity hover:opacity-100" style={{ color: 'inherit' }}>
                FAQ
              </Link>
              <Link to="/blog" className="text-sm opacity-90 transition-opacity hover:opacity-100" style={{ color: 'inherit' }}>
                Blog
              </Link>
              <Link to="/contact" className="text-sm opacity-90 transition-opacity hover:opacity-100" style={{ color: 'inherit' }}>
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="flex flex-col space-y-3">
              <div className="flex items-center space-x-3">
                <Phone size={18} className="flex-shrink-0" />
                <a href={`tel:${siteInfo.phone}`} className="text-sm opacity-90 hover:opacity-100 transition-opacity">
                  {siteInfo.phone}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={18} className="flex-shrink-0" />
                <a href={`mailto:${siteInfo.email}`} className="text-sm opacity-90 hover:opacity-100 transition-opacity">
                  {siteInfo.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm opacity-75">
              © {new Date().getFullYear()} Paix Family Mediation. All rights reserved.
            </p>
            <p className="text-sm opacity-75">
              Serving Los Angeles and throughout California
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
